//wfs-分段设色图
import { getDispatcher } from '@/utils/analysisTools/';
import WFSBean from '@/utils/analysisTools/beans/WFSBean';

import ReaderColorLayer from '../components/ReaderColorLayer.js';
import {MiscUtil} from "../../../../utils/miscUtil";

export default {
    async initLayer(vm, planInfo) {
        const MapView = vm.MapView;

        const result = {};
        const param = this.checkParameter(planInfo);
        if (param) {
            const {
                zoomRange,
                /* serviceQueryField, */
                colors,
                ranges,
                url,
                layerName,
                field,
                showMap,
                mapMatchField,
            } = param;
            const features = await this.getFeatures(vm, url, layerName);
            const fillStops = [];
            const hoverField = 'hoverId';
            for (let i = 0; i < features.length; i++) {
                const feature = features[i];
                feature.properties[field] = Number(feature.properties[field]);
                feature.properties[hoverField] = i;

                fillStops.push(
                    this.getFillStops(feature.properties[field], colors, ranges)
                );
            }
            fillStops.sort(function (a, b) {
                return a[0] - b[0];
            });
            const wfsLayer = new ReaderColorLayer('custom', zoomRange);
            wfsLayer.setMap(MapView.map);
            wfsLayer.setData(features);
            wfsLayer.Styles = {
                point: {
                    'circle-radius': 6,
                    'circle-color': {
                        property: field,
                        stops: fillStops,
                    },
                },
                line: {
                    'line-color': '#FFF',
                    'line-opacity': 1,
                    'line-width': 1,
                },
                polygon: {
                    'fill-color': {
                        property: field,
                        stops: fillStops,
                    },
                    'fill-opacity': 0.8,
                },
            };
            const wfsLayerHover = new ReaderColorLayer('custom', zoomRange);
            wfsLayerHover.setMap(MapView.map);
            wfsLayerHover.id.forEach(l => {
                MapView.map.setFilter(l, ['==', hoverField, '']);
            });
            wfsLayerHover.setData(features);
            wfsLayerHover.Styles = {
                point: {
                    'circle-radius': 1,
                    'circle-color': 'red',
                },
                line: {
                    'line-color': '#187aff',
                    'line-opacity': 1,
                    'line-width': 2,
                },
                polygon: {
                    'fill-color': 'red',
                    'fill-opacity': 0,
                },
            };
            result.info = true;
            result.data = [wfsLayer, wfsLayerHover];
            result.param = {
                fillStops,
                colors,
                ranges,
                field,
                showMap,
                mapMatchField,
            };
            return result;
        } else {
            result.info = false;
            return result;
        }
    },
    //检查参数是否完整
    checkParameter(json) {
        try {
            const parameter = {};
            parameter.zoomRange = json.configcont.basic.zoomRange;
            const thematic = json.configcont.thematic;
            parameter.serviceQueryField = thematic.serviceQueryField;
            parameter.colors = thematic.mapFieldColors;
            parameter.ranges = thematic.mapFieldRanges;
            parameter.url = thematic.mapUrl;
            parameter.layerName = thematic.mapLayer;
            parameter.field = thematic.mapQueryField;
            parameter.showMap = thematic.showMap;
            parameter.mapMatchField = thematic.mapMatchField;
            for (const values of Object.values(parameter)) {
                if (values === undefined) {
                    return false;
                }
            }
            return parameter;
        } catch {
            return false;
        }
    },
    getFillStops(value, colors, ranges) {
        let fillStop = null;
        for (let i = 0; i < ranges.length; i++) {
            if (value >= ranges[i] && value < ranges[i + 1]) {
                fillStop = [value, colors[i]];
            }
        }
        return fillStop;
    },
    async getFeatures(vm, url, layerName) {
        // url= MiscUtil.getProxyUrl(url)
        const queryParams = {
            url: url,
            layerName: layerName,
        };
        const bean = new WFSBean(queryParams);
        return new Promise((resolve, reject) => {
            getDispatcher(vm)
                .read(bean)
                .then(result => {
                    resolve(result.geojson);
                })
                .catch(() => {
                    vm.$Message.error('方案数据解析失败，请检查数据配置！');
                    reject();
                });
        });
    },
};
